/**
 * Helper functions for connection status component
 */

import connectionService from '../../services/ConnectionService';

/**
 * Check connection quality by measuring response time
 * @returns {Promise<{isOnline: boolean, connectionQuality: string}>}
 */
export const checkConnectionQuality = async () => {
  const startTime = Date.now();
  try {
    const isOnline = await connectionService.checkActiveConnection();
    
    if (!isOnline) {
      return {
        isOnline: false,
        connectionQuality: 'offline'
      };
    }
    
    const endTime = Date.now();
    const responseTime = endTime - startTime;
    
    // Determine connection quality based on response time
    let connectionQuality = 'good';
    if (responseTime > 1000) {
      connectionQuality = 'poor';
    } else if (responseTime > 500) {
      connectionQuality = 'moderate';
    }
    
    return {
      isOnline: true,
      connectionQuality,
      responseTime
    };
  } catch (error) {
    return {
      isOnline: false,
      connectionQuality: 'error',
      error
    };
  }
};
